import { createFileRoute } from '@tanstack/react-router'
import { CandidateChatList } from '@/features/candidate-chat'

export const Route = createFileRoute('/_authenticated/candidate-chat/')({
  component: CandidateChatList,
})
